<template>
  <div>
    <exchange-modal ref="exchangeModal" @exchange-result="handleExchangeStatus" @show-loading="handleLoading"></exchange-modal>
    <exchange-success-modal :isVisible="exchangeStatus === STATUS.SUCCESS" :target="target" @close-modal="handleCloseModal"></exchange-success-modal>
    <exchange-fail-modal :isVisible="exchangeStatus === STATUS.FAIL" :retcode="retcode" @close-modal="handleCloseModal" @retry-exchange="handleRetry"></exchange-fail-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ExchangeModal from '@/components/fengyou/ExchangeModal'
import ExchangeSuccessModal from '@/components/fengyou/ExchangeSuccessModal'
import ExchangeFailModal from '@/components/fengyou/ExchangeFailModal'

const STATUS = {
  INITIAL: null,    // 初始状态
  SUCCESS: true,    // 成功状态
  FAIL: false      // 失败状态
}

export default {
  data() {
    return {
      showExchangeModal: false,
      exchangeStatus: STATUS.INITIAL,
      retcode: -1,
      target: '-1'
    };
  },
  components: { ExchangeModal, ExchangeSuccessModal, ExchangeFailModal },
  methods: {
    show (couponHis) {
      this.$refs.exchangeModal.show(couponHis)
    },
    handleExchangeStatus (result, serverResponse) {
      this.exchangeStatus = result ? STATUS.SUCCESS : STATUS.FAIL

      if (serverResponse) {
        this.retcode = serverResponse.retcode

        const brandType = this.h5ConfigDetails[0]['fengyou']['brandType']
        const target = brandType.findIndex((cur) => {
          return cur === serverResponse.gameName
        })
        if (target < 0) {
          this.$toast('缺少说明配置！')
          return
        }
        this.target = String(target)
      }
    },
    handleCloseModal () {
      this.exchangeStatus = STATUS.INITIAL
    },
    handleLoading (showing) {
      if (showing) {
        this.$parent.$refs.loadingShow.show()
      } else {
        this.$parent.$refs.loadingShow.close()
      }
    },
    handleRetry () {
      this.exchangeStatus = STATUS.INITIAL
      this.$refs.exchangeModal.handleExchange()
    }
  },
  computed: {
    ...mapState(['h5ConfigDetails']),
    STATUS: () => STATUS // 通过计算属性暴露给模板
  }
}
</script>

<style>

</style>